<template>
  <div>
    <h2>{{ $props.question }}</h2>
    <div class="wrapper">
      <img
        class="approve-image shadow"
        :src="$props.image"
        :alt="$props.question"
      />
      <font-awesome-icon
        class="icon icon-no grow hide-on-mobile"
        :class="{ 'selected-no': selectedValue === false }"
        :icon="['fas', 'times-circle']"
        @click="onSelect(false)"
      />
      <font-awesome-icon
        class="icon icon-yes grow hide-on-mobile"
        :class="{ 'selected-yes': selectedValue === true }"
        :icon="['fas', 'check-circle']"
        @click="onSelect(true)"
      />
    </div>
    <div class="wrapper">
      <font-awesome-icon
        class="icon icon-no grow hide-on-desktop"
        :class="{ 'selected-no': selectedValue === false }"
        :icon="['fas', 'times-circle']"
        @click="onSelect(false)"
      />
      <font-awesome-icon
        class="icon icon-yes grow hide-on-desktop"
        style="margin-left: 60px"
        :class="{ 'selected-yes': selectedValue === true }"
        :icon="['fas', 'check-circle']"
        @click="onSelect(true)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ApproveInput",
  props: {
    question: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    selectedValue: {
      required: true
    },
    clickedCallback: {
      type: Function,
      required: true
    }
  },
  methods: {
    onSelect(val) {
      this.$props.clickedCallback(val);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.approve-image {
  max-height: 400px;
  border-radius: 10px;
  margin: 20px 40px 20px 40px;
  order: 2;
}

.hide-on-desktop {
  display: none;
}

@media only screen and (max-width: 768px) {
  .approve-image {
    max-width: 60%;
  }
  .approve-image {
    order: 1;
  }
  .hide-on-desktop {
    margin-top: 40px;
    display: flex;
  }
  .hide-on-mobile {
    display: none;
  }
}
.icon {
  font-size: 72px;
  cursor: pointer;
  border-radius: 50px;
  border: 5px solid #fff;
}
.icon-yes {
  color: $color-primary;
  order: 3;
}
.selected-yes {
  border: 5px solid $color-primary;
}
.icon-no {
  color: $color-gray;
  order: 1;
}
.selected-no {
  border: 5px solid $color-gray;
}
</style>
